import { ValidationMessage, ValidationProps } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CompanyReportItemValidation } from 'app/area/company-reports-administration/form/types-store';

export const clearValidationForKey = (
  validation: CompanyReportItemValidation,
  key: keyof CompanyReportItemValidation
): CompanyReportItemValidation => clearValidationForKeys(validation, [key]);

export const clearValidationForKeys = (
  validation: CompanyReportItemValidation,
  keys: (keyof CompanyReportItemValidation)[]
): CompanyReportItemValidation => {

  if (!validation ||
    !Object.keys(validation).some(key => (validation?.[key]?.messages?.length ?? 0) > 0)) {
    return validation;
  }

  return Object.keys(validation).reduce((currentValidation, currentKey) =>
    keys.includes(currentKey as keyof CompanyReportItemValidation)
      ? currentValidation
      : {
        ...currentValidation,
        [currentKey]: validation[currentKey]
      }, {});
};

export const clearValidationForSingleParameter = (
  validation: CompanyReportItemValidation,
  key: string,
  parameter: string,
  id: number
): CompanyReportItemValidation => {
  if (!validation ||
    (Array.isArray(validation[key])
      ? ((validation[key] as ValidationProps[])?.find(validationProps => (validationProps.messages?.length ?? 0) === 0))
      : ((validation[key] as ValidationProps)?.messages?.length ?? 0) === 0)) {
    return validation;
  }

  const messages = (Array.isArray(validation[key])
    ? (validation[key] as ValidationProps[]).flatMap(message => message.messages)
    : (validation[key] as ValidationProps).messages).filter(
      (m: ValidationMessage) => !m || !m.parameters ||
        !isDefinedIncludingZero(m.parameters[parameter]) || m.parameters[parameter] !== id);

  if (messages.length === 0) {
    const { [key as keyof CompanyReportItemValidation]: _, ...validationRest } = validation;

    return validationRest;
  }

  return {
    ...validation,
    [key]: {
      ...validation[key],
      messages
    }
  };
};

export const clearValidationForAllParameters = (
  validation: CompanyReportItemValidation,
  key: string,
  parameter: string
): CompanyReportItemValidation => {
  if (!validation ||
    (Array.isArray(validation[key])
      ? ((validation[key] as ValidationProps[])?.find(validationProps => (validationProps.messages?.length ?? 0) === 0))
      : ((validation[key] as ValidationProps)?.messages?.length ?? 0) === 0)) {
    return validation;
  }

  const messages = (Array.isArray(validation[key])
    ? (validation[key] as ValidationProps[]).flatMap(message => message.messages)
    : (validation[key] as ValidationProps).messages).filter(
      (m: ValidationMessage) => !m || !m.parameters || !isDefinedIncludingZero(m.parameters[parameter]));

  if (messages.length === 0) {
    const { [key as keyof CompanyReportItemValidation]: _, ...validationRest } = validation;

    return validationRest;
  }

  return {
    ...validation,
    [key]: {
      ...validation[key],
      messages
    }
  };
};
